import { jsxs as V, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as C } from "./index.es2359.js";
function d({ size: e = C }) {
  return /* @__PURE__ */ V(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l("path", { d: "M17 30H27V39H17V30Z", fill: "white" }),
        /* @__PURE__ */ l("path", { d: "M36 40H31L31 32C31 31.4477 31.4477 31 32 31L36 31V40Z", fill: "white" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M33 21H40V24.5C40 26.433 38.433 28 36.5 28C34.567 28 33 26.433 33 24.5V21Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28 21H35V24.5C35 26.433 33.433 28 31.5 28C29.567 28 28 26.433 28 24.5V21Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M24 21H30V24C30 25.6569 28.6569 27 27 27C25.3431 27 24 25.6569 24 24V21Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M21.3333 29H27.4848C27.7694 29 28 29.2306 28 29.5152V31.3333C28 33.1743 26.5076 34.6667 24.6667 34.6667C22.8257 34.6667 21.3333 33.1743 21.3333 31.3333V29Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M16 29H22.6667V31.3333C22.6667 33.1743 21.1743 34.6667 19.3333 34.6667C17.4924 34.6667 16 33.1743 16 31.3333V29Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17 18.5C17 17.6716 17.7021 17 18.5682 17H38.4318C39.2979 17 40 17.6716 40 18.5V38.5C40 39.3284 39.2979 40 38.4318 40H29V39H38.4318C38.7205 39 38.9545 38.7761 38.9545 38.5V18.5C38.9545 18.2239 38.7205 18 38.4318 18H18.5682C18.2795 18 18.0455 18.2239 18.0455 18.5V28H17V18.5Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M32 39H35V32H32L32 39ZM36 40V31H32C31.4477 31 31 31.4477 31 32L31 40H36Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21 37V39H23V37H21ZM20 40H24V37C24 36.4477 23.5523 36 23 36H20V40Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 29H22.6667V31.3333C22.6667 33.1743 21.1743 34.6667 19.3333 34.6667C18.4248 34.6667 17.6013 34.3032 17 33.7138V39L27 39V30H28V40H17C16.4477 40 16 39.5523 16 39V29ZM17 30H21.6667V31.3333C21.6667 32.622 20.622 33.6667 19.3333 33.6667C18.0447 33.6667 17 32.622 17 31.3333V30Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7792 33C22.3555 33.9963 23.4328 34.6667 24.6666 34.6667C26.5075 34.6667 27.9999 33.1743 27.9999 31.3333V29.5152C27.9999 29.2306 27.7693 29 27.4848 29H22V33H21.7792ZM22.3333 30H27L26.9999 31.3333C26.9999 32.622 25.9552 33.6667 24.6666 33.6667C23.3779 33.6667 22.3333 32.622 22.3333 31.3333V30Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24 21H30V24C30 25.6569 28.6569 27 27 27C26.2316 27 25.5308 26.7111 25 26.2361V28H24V21ZM25 22H29V24C29 25.1046 28.1046 26 27 26C25.8954 26 25 25.1046 25 24V22Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28.3368 26C28.8985 27.1825 30.1038 28 31.5 28C33.433 28 35 26.433 35 24.5V21H29L29 22H34V24.5C34 25.8807 32.8807 27 31.5 27C30.1193 27 29 25.8807 29 24.5V26H28.3368Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M34 26.9495C34.6353 27.5978 35.5207 28 36.5 28C38.433 28 40 26.433 40 24.5V21H34V22H39V24.5C39 25.8807 37.8807 27 36.5 27C35.1193 27 34 25.8807 34 24.5V26.9495Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
d.__tags = [];
export {
  d as MetricFrequentCoTenantsIcon
};
//# sourceMappingURL=index.es392.js.map
